import { Component, HostBinding, Input } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faLock } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'ng-casto-button',
  templateUrl: './button.component.html',
})
export class ButtonComponent {
  @HostBinding('class.loading') private get _loading() {
    return this.loading;
  }

  @HostBinding('class.disabled') private get _disabled() {
    return this.disabled;
  }

  @HostBinding('class.circle') private get _circle() {
    return !this.label && this.faIcon;
  }

  @HostBinding('class.locked') private get _locked() {
    return this.locked;
  }

  @Input() locked: boolean;
  @Input() disabled: boolean;
  @Input() loading: boolean;
  @Input() label: string;
  @Input() color: string;

  /** Icône optionnelle de la librairie font awesome */
  @Input() faIcon?: IconDefinition;
  /** Font size de l'icône optionnelle, medium par défaut. */
  @Input() faSize?: string = 'medium';

  protected readonly faLock = faLock;

  disabledAreaClick(e: Event) {
    e.stopPropagation();
    e.preventDefault();
  }
}
